// Plain (non-React) helpers for reading/writing the stored Cognito ID token.
// Kept separate from AuthContext so api/client.ts can read the token without importing React
// context code (avoids a circular dependency between api/ and auth/).

const ID_TOKEN_KEY = 'omnist.idToken';
const REFRESH_TOKEN_KEY = 'omnist.refreshToken';
const MOCK_USER_KEY = 'omnist.mockUser';

export function getIdToken(): string | null {
  try {
    return sessionStorage.getItem(ID_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setIdToken(token: string): void {
  try {
    sessionStorage.setItem(ID_TOKEN_KEY, token);
  } catch {
    // sessionStorage unavailable (e.g. private mode edge cases) -- fail silently, auth just
    // won't persist across reloads.
  }
}

/** Only set for the Google/Hosted-UI flow -- SRP sign-in relies on
 * amazon-cognito-identity-js's own cached session instead (see cognitoSrp.ts's
 * restoreSession()), since the SDK manages that refresh token itself. */
export function getRefreshToken(): string | null {
  try {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setRefreshToken(token: string): void {
  try {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
  } catch {
    // ignore
  }
}

export function clearIdToken(): void {
  try {
    sessionStorage.removeItem(ID_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(MOCK_USER_KEY);
  } catch {
    // ignore
  }
}

export function isMockMode(): boolean {
  return String(import.meta.env.VITE_USE_MOCK ?? 'true').toLowerCase() === 'true';
}
